import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { waLink } from "@/lib/scroll";

const CtaBand = ({ wa }) => (
  <section data-testid="cta-band" className="relative bg-[#151A1F] py-20 sm:py-24 overflow-hidden border-t border-[#00A651]/25">
    <div className="absolute inset-0 hairlines" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-6 sm:px-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-8">
      <div>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="font-display font-bold tracking-tight text-2xl sm:text-4xl"
        >
          Cotizá tu aplicación hoy.
        </motion.h2>
        <p className="mt-3 text-[#F6F7F5]/60 text-base">Precio por hectárea el mismo día. Sin compromiso.</p>
      </div>
      <div className="flex flex-wrap gap-4">
        <Link
          data-testid="cta-band-cotizar"
          to="/cotizar"
          className="bg-[#FFB000] text-[#151A1F] font-display font-semibold px-8 py-4 rounded-full text-base hover:scale-[1.03] transition-transform duration-300"
        >
          Ir al cotizador
        </Link>
        <a
          data-testid="cta-band-whatsapp"
          href={waLink(wa || "Hola Fumiga, quiero cotizar aplicación con dron.")}
          target="_blank"
          rel="noopener noreferrer"
          className="border border-[#F6F7F5]/25 text-[#F6F7F5] font-display font-medium px-8 py-4 rounded-full text-base hover:border-[#00A651] hover:text-[#00A651] transition-colors duration-300"
        >
          Escribir por WhatsApp
        </a>
      </div>
    </div>
  </section>
);

export default CtaBand;
